/* eslint-disable */
$(function () {
    let ndtServer;
    let server_city;
    let server_country;
    let websocket_client = null;
    const mlabNsService = 'https:' == location.protocol ? 'ndt_ssl' : 'ndt';
    const mlabNsUrl = 'https://mlab-ns.appspot.com/';

    $.ajax({
        url: mlabNsUrl + mlabNsService + '?format=json',
        dataType: 'json',
        success: function (resp) {
            server_city = resp.city;
            server_country = resp.country;
            ndtServer = resp.fqdn;
            // show the start test button
            $('.start-speed-test').removeClass('hidden');
        },
        error: function (jqXHR, errStatus, errText) {
            console.log('mlab-ns lookup failed: ' + errStatus + ' ' + errText);
            $('.speed-test-error').removeClass('hidden');
        },
    });

    function testError() {
        return testNDT().get_errmsg();
    }

    function testStatus() {
        return testNDT().get_status();
    }

    function getJustfiedSpeed(speedInKB) {
        var e = Math.floor(Math.log(speedInKB) / Math.log(1000));
        var fixedNum = 2;
        if (speedInKB > 100) {
            fixedNum = 0;
        } else if (speedInKB > 10) {
            fixedNum = 1;
        }
        return (speedInKB / Math.pow(1000, e)).toFixed(fixedNum);
    }

    function getSpeedUnit(speedInKB) {
        var unit = ['kbps', 'Mbps', 'Gbps', 'Tbps', 'Pbps', 'Ebps'];
        var e = Math.floor(Math.log(speedInKB * 1000) / Math.log(1000));
        return unit[e];
    }

    function readNDTvar(variable) {
        var ret = testNDT().getNDTvar(variable);
        return !ret ? '-' : ret;
    }

    function printNumberValue(value) {
        return isNaN(value) ? '-' : value;
    }

    function printPacketLoss() {
        var packetLoss = parseFloat(testNDT().getNDTvar('loss'));
        packetLoss = (packetLoss * 100).toFixed(2);
        return packetLoss;
    }

    function averageRoundTrip() {
        return parseFloat(testNDT().getNDTvar('avgrtt'));
    }

    function jitter() {
        return parseFloat(testNDT().getNDTvar('Jitter'));
    }

    function printJitter(boldValue) {
        var retStr = '';
        var jitterValue = jitter();
        if (jitterValue >= 1000) {
            retStr +=
                (boldValue ? '<b>' : '') +
                printNumberValue(jitterValue / 1000) +
                (boldValue ? '</b>' : '') +
                ' sec';
        } else {
            retStr +=
                (boldValue ? '<b>' : '') +
                printNumberValue(jitterValue) +
                (boldValue ? '</b>' : '') +
                ' msec';
        }
        return retStr;
    }

    function testDetails() {
        var d = '';

        // d += 'Your system: ' + readNDTvar('OperatingSystem').bold() + '<br>';
        // d += 'Plugin version: ' + (readNDTvar('PluginVersion') + ' (' + readNDTvar('OsArchitecture') + ')<br>').bold();

        // d += '<br>';

        d +=
            '<table><tr><td>Round trip time (Latency):&nbsp;&nbsp; </td><td><b>' +
            printNumberValue(Math.round(averageRoundTrip())) +
            '</b> msec (average)</td></tr><tr><td></td><td>' +
            readNDTvar('MinRTT').bold() +
            ' msec (minimum)</td></tr><tr><td><td>' +
            readNDTvar('MaxRTT').bold() +
            ' msec (maximum)</td></tr></table>';

        // d += '<p>Jitter: ' + printNumberValue(printJitter(true)) + '</p>';

        d += '<div class="font-small">';
        d +=
            '<p><br>' +
            printNumberValue(printPacketLoss()) +
            '% of packets lost during test</p>';
        d +=
            'TCP receive window: ' +
            readNDTvar('CurRwinRcvd').bold() +
            ' current, ' +
            readNDTvar('MaxRwinRcvd').bold() +
            ' maximum<br>';
        d +=
            readNDTvar('waitsec').bold() +
            ' seconds spend waiting following a timeout<br>';
        d += 'TCP time-out counter: ' + readNDTvar('CurRTO').bold() + '<br>';
        d +=
            readNDTvar('SACKsRcvd').bold() +
            ' selective acknowledgement packets received<br>';

        d += '<br>';

        if (readNDTvar('mismatch') == 'yes') {
            d += 'A duplex mismatch condition was detected.<br>'
                .fontcolor('red')
                .bold();
        } else {
            d += 'No duplex mismatch condition was detected.<br>'.fontcolor(
                'green'
            );
        }

        if (readNDTvar('bad_cable') == 'yes') {
            d += 'The test detected a cable fault.<br>'.fontcolor('red').bold();
        } else {
            d += 'The test did not detect a cable fault.<br>'.fontcolor(
                'green'
            );
        }

        if (readNDTvar('congestion') == 'yes') {
            d += 'Network congestion may be limiting the connection.<br>'
                .fontcolor('red')
                .bold();
        } else {
            d += 'No network congestion was detected.<br>'.fontcolor('green');
        }

        d += '<br>';

        d +=
            printNumberValue(readNDTvar('cwndtime')).bold() +
            ' % of the time was not spent in a receiver limited or sender limited state.<br>';
        d +=
            printNumberValue(readNDTvar('rwintime')).bold() +
            " % of the time the connection is limited by the client machine's receive buffer.<br>";
        // d += 'Optimal receive buffer: ' + printNumberValue(readNDTvar('optimalRcvrBuffer')).bold() + ' bytes<br>';
        // d += 'Bottleneck link: ' + readNDTvar('accessTech').bold() + '<br>';
        d += readNDTvar('DupAcksIn').bold() + ' duplicate ACKs set<br>';
        d += '</div>';

        return d;
    }

    function monitorTest() {
        let message = testError();
        let currentStatus = testStatus();
        let speed = 0;

        if (currentStatus === 'Outbound') {
            // upload speed
            speed = readNDTvar('ClientToServerSpeed');
            if (speed > 0) {
                // hide initializing text
                $('.speed-test-2 .initializing-test .thinking').removeClass(
                    'active'
                );
                $('.speed-test-2 .initializing-test').addClass('hidden');
                // show next step
                $('.speed-test-2 .speed-test-content').fadeIn();
                $('.speed-test-2 .test-thinking').addClass('active');
                $('.text-value-upload')
                    .html(getJustfiedSpeed(speed))
                    .css('opacity', '.7');
                $('.upload-units').html(getSpeedUnit(speed));
                $('.upload-test-finished')
                    .html(
                        getJustfiedSpeed(speed) +
                            ' ' +
                            getSpeedUnit(speed) +
                            ' Upload'
                    )
                    .css('opacity', '.7'); // set upload for next step
            }
        }

        if (currentStatus == 'Inbound') {
            // download speed
            $('.speed-test-2').addClass('hidden');
            $('.speed-test-2 .loader').removeClass('active');
            $('.speed-test-3').removeClass('hidden');
            $(
                '.speed-test-3 .loader, .speed-test-3 .initializing-test .thinking'
            ).addClass('active');
            speed = readNDTvar('ServerToClientSpeed');
            if (speed > 0) {
                $('.speed-test-3 .initializing-test .thinking').removeClass(
                    'active'
                );
                $('.speed-test-3 .initializing-test').addClass('hidden');
                $('.speed-test-3 .speed-test-content').fadeIn();
                $('.speed-test-3 .test-thinking').addClass('active');
                $('.speed-test-3 .test-value-download')
                    .html(getJustfiedSpeed(speed))
                    .css('opacity', '.7');
                $('.speed-test-3 .download-units').html(getSpeedUnit(speed));
            }
        }

        if (message === 'Test completed') {
            // test completed
            const downloadSpeed = readNDTvar('ServerToClientSpeed');
            const uploadSpeed = readNDTvar('ClientToServerSpeed');
            const latency = printNumberValue(Math.round(averageRoundTrip()));
            $('.speed-test-content').hide();
            $('.speed-test-3').addClass('hidden');
            $('.speed-test-4').removeClass('hidden');
            $('.thinking, .loader').removeClass('active');
            $('.speed-test-4 .test-value-download').html(
                getJustfiedSpeed(downloadSpeed)
            );
            $('.speed-test-4 .download-units').html(
                getSpeedUnit(downloadSpeed)
            );
            $('.speed-test-4 .upload-test-finished')
                .html(
                    getJustfiedSpeed(uploadSpeed) +
                        ' ' +
                        getSpeedUnit(uploadSpeed) +
                        ' Upload'
                )
                .css('opacity', '1');
            $('#test-details').html(testDetails());
            $('.speed-test-zipcheck, .speed-test-final').addClass('active');

            const provider = encodeURIComponent(mm_provider);

            // save all the data
            let dataString = `ip=${user_ip}&server=${ndtServer}&server_city=${server_city}&server_country=${server_country}&connection_type=${mm_connection_type}&upload_speed=${uploadSpeed}&download_speed=${downloadSpeed}&zip=${mm_zip}&city=${mm_city}&state=${mm_state}&provider=${provider}&country=${mm_country}&latency=${latency}`;

            dataString = encodeURI(dataString);

            const justifiedDownload = getJustfiedSpeed(downloadSpeed);
            const downloadUnit = getSpeedUnit(downloadSpeed);
            const rangeArray = [
                '0-5 Mbps',
                '5-10 Mbps',
                '10-20 Mbps',
                '20-40 Mbps',
                '40-60 Mbps',
                '60-100 Mbps',
                '100+ Mbps',
            ];
            let speedRange;

            if (downloadUnit === 'kbps') {
                speedRange = rangeArray[0];
            } else if (justifiedDownload < 5) {
                speedRange = rangeArray[0];
            } else if (justifiedDownload < 10) {
                speedRange = rangeArray[1];
            } else if (justifiedDownload < 20) {
                speedRange = rangeArray[2];
            } else if (justifiedDownload < 40) {
                speedRange = rangeArray[3];
            } else if (justifiedDownload < 60) {
                speedRange = rangeArray[4];
            } else if (justifiedDownload < 100) {
                speedRange = rangeArray[5];
            } else if (justifiedDownload >= 100) {
                speedRange = rangeArray[6];
            }

            dataLayer.push({
                event: 'speedtest',
                download_speed: speedRange,
                provider: mm_provider,
                connection: mm_connection_type,
            });

            $.ajax({
                type: 'POST',
                data: 'action=saveSpeedTest&' + dataString,
                url: '/wp/wp-admin/admin-ajax.php',
                success: function (e) {
                    if (e == '1') {
                        // it worked
                        // console.log('data saved');
                    } else {
                        console.log('There was an error');
                    }
                },
            });
        } else {
            setTimeout(monitorTest, 1000);
        }
    }

    function testNDT() {
        return websocket_client;
    }

    function startTest() {
        $('.speed-test-1, .speed-test-4').addClass('hidden');
        $('.speed-test-zipcheck, .speed-test-final').removeClass('active');
        $('.speed-test-2, .initializing-test').removeClass('hidden');
        $(
            '.speed-test-2 .loader, .speed-test-2 .initializing-test .thinking'
        ).addClass('active');

        websocket_client = new NDTWrapper(ndtServer);
        testNDT().run_test(ndtServer);
        monitorTest();
    }

    $('.start-speed-test').click(() => {
        startTest();
    });
});
/* eslint-enable */
